"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const MenuContext = /*#__PURE__*/_react.default.createContext({
  hoverIndex: -1,
  hoverIndexDispatch: undefined
});
var _default = exports.default = MenuContext;